import { css } from 'linaria';

export const metalRoofGallery = css`
  && {
    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    > div {
      @media (--only-tablet) {
        height: 216px;
      }
    }

    div:nth-of-type(10n -5),
    div:nth-of-type(10n -2) {
      @media (--only-tablet) {
        height: 456px;
      }
    }
  }
`;

export const metalRoofGalleryTwoSellers = css`
  && {
    div:nth-of-type(18) {
      grid-row-start: unset;
      height: 380px;

      @media (--to-desktop) {
        height: 216px;
      }
    }
  }
`;
